<template>
    <div class="position-absolute right-0">
        <modal ref="risk_modal" title="SSOW RA Guide" :close_on_focus="true">
            <div class="row">
                <div class="col-7">
                    <img class="mw-100" src="/svg/ssow/table.svg">
                </div>
                <div class="col-5">
                    <img class="mw-100" src="/svg/ssow/chart.svg">

                    <p class="mt-4 mb-1">Risk Factor = likelihood x severity</p>
                    <img class="mw-100" src="/svg/ssow/chart-key.svg">
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
	import Modal from "../general_components/Modal";
	export default {
		name: "RiskAssessmentModal",
		components: {Modal},
		props: {
            companyStyle: {
                type: String,
                required: true
            }
        },

        methods: {
			open(){
                this.$refs.risk_modal.openModal();
            }
        }
	}
</script>
